import React from 'react';
import cx from 'classnames';
import styles from './CampaignsTablePlaceholder.module.scss';
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { DlsFontVariants, DlsColorTokens } from '@/constants/DLSTokens';
import { Image } from '@swiggy-private/dls-web-core/dist/components/Image';
const TITLE = 'No active campaign found';
const SUB_TITLE = 'Your active campaign data would show-up here';
const EMPTY_STATE_IMAGE = '/v1690198940/InstamartAssets/B2B%20Assets/Error-empty_state.png';
const IMAGE_SIZE = 160;
function CampaginsTablePlaceholder(props) {
    var _a, _b;
    return (React.createElement("div", { className: cx(props.className, styles.container) },
        React.createElement(Image, { cloudinaryId: EMPTY_STATE_IMAGE, cloudinaryHeight: IMAGE_SIZE * 2, cloudinaryWidth: IMAGE_SIZE * 2, height: `${IMAGE_SIZE}px`, width: `${IMAGE_SIZE}px`, className: styles.image }),
        React.createElement("div", { className: styles.text },
            React.createElement(Text, { variant: DlsFontVariants.header_H4_Black, color: DlsColorTokens.text_Highest_Emphasis }, (_a = props.title) !== null && _a !== void 0 ? _a : TITLE),
            React.createElement(Text, { variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_High_Emphasis }, (_b = props.subTitle) !== null && _b !== void 0 ? _b : SUB_TITLE))));
}
export default CampaginsTablePlaceholder;
